import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./styles/financialItemStyle";
import TableContainer from "@material-ui/core/TableContainer";

type VoucherDataProps = {
  voucherData: Array<Object>;
  voucherTotalAmount: number;
  source: string;
};


export const VoucherSummary: FunctionComponent<VoucherDataProps> = ({
  voucherData,
  voucherTotalAmount,
  source,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container style={{ paddingTop: "2.4em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>Voucher Summary</Typography>
            </Grid>
          </Grid>
          <Table
            size="small"
            aria-label="a dense table"
            className={source === "print" ? classes.table : ""}
          >
            <TableHead className={classes.tableRow}>
              <TableRow>
                <TableCell
                  align="center"
                  className={classes.headColor}
                  style={{ width: "30%" }}
                ></TableCell>

                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Bills
                </TableCell>
                <TableCell align="right" className={classes.headCell}>
                  Items
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {!!voucherData?.length &&
                voucherData.map((data: any) => (
                  <TableRow>
                    <TableCell align="left" className={classes.headColor}>
                      {data.v_name}
                    </TableCell>
                    <TableCell
                      align="right"
                      className={classes.headColor}
                    ></TableCell>
                    <TableCell align="right" className={classes.headColor}>
                      {data.v_count ? data.v_count : "0"}
                    </TableCell>
                    <TableCell align="right" className={classes.headColor}>
                      {data.v_amount ? data.v_amount : "0.00"}
                    </TableCell>
                  </TableRow>
                ))}

              <TableRow>
                <TableCell
                  align="left"
                  className={classes.headCell}
                  colSpan={3}
                >
                  Total
                </TableCell>

                <TableCell align="right" className={classes.headCell}>
                {voucherTotalAmount.toFixed(2)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
